/* eslint-disable camelcase */
/**
 * This file is AUTO GENERATED by [msw-auto-mock](https://github.com/zoubingwu/msw-auto-mock)
 * Feel free to commit/edit it as you need.
 */

import { faker } from '@faker-js/faker/locale/en';
import {
  delay,
  http,
  HttpResponse,
} from 'msw';

import { apiEndpoints } from '../../lib';
import {
  getMockedAccessToken,
  getSimplifiedAccountById200Response,
  mockMessage,
} from '../mock-helpers';
import { contractHandlers } from './contractHandlers';

// change this to Date.now() randomize the fake values more
faker.seed(1);

export const handlers = {
  accountSummary: http.get(
    apiEndpoints.accountSummary(':accountId'),
    () => HttpResponse.json(getSimplifiedAccountById200Response(), { status: 200 }),
  ),
  blocAccountSummary: http.get(
    apiEndpoints.blocAccountSummary(':accountId'),
    () => HttpResponse.json(
      {
        account_id: faker.number.int(),
        due_date_adjustment_eligible: faker.datatype.boolean(),
        first_name: faker.person.firstName(),
        last_name: faker.person.lastName(),
        login: faker.internet.email(),
        open_loan_number: `LOAN${faker.number.int({ max: 999999, min: 100000 })}`,
        open_loan_type: 'cnu_bank_partnership_ccb_loc',
        show_fee_saver_status: faker.datatype.boolean(),
      },
      { status: 200 },
    ),
  ),
  blocActiveLoanSummary: http.get(
    apiEndpoints.blocActiveLoanSummary(':accountId', ':loanNumber'),
    () => HttpResponse.json(
      {
        data: {
          automatic_payment_eligible: faker.datatype.boolean(),
          due_date_adjustment_eligible: faker.datatype.boolean(),
          gov_law_state_cd: faker.location.state({ abbreviated: true }),
          id: faker.number.int(),
          open_loan_number: `LOAN${faker.number.int({ max: 999999, min: 100000 })}`,
          open_loan_type: 'cnu_bank_partnership_ccb_loc',
        },
      },
      { status: 200 },
    ),
  ),
  // Hand-added, not from msw-auto-mock: the contract payload the signing flow renders.
  contract: contractHandlers.success,
  messages: http.get(
    apiEndpoints.messages(':accountId'),
    async ({ request }) => {
      const url = new URL(request.url);
      const limit = +(url.searchParams.get('limit') || 10);
      const offset = +(url.searchParams.get('offset') || 0);

      const messagesArr = [];

      for (let i = 0; i < 20; i++) {
        faker.seed(i);
        messagesArr.push(mockMessage(i + 1001));
      }

      await delay();

      const thisSlice = messagesArr.slice(offset, offset + limit);

      return HttpResponse.json(
        // TEMP PAGINATION HACK: To be reverted once the total count is fixed.
        // { count: messagesArr.length, messages: messagesArr.slice(offset, offset + limit) },
        { data: { count: Math.min(limit, thisSlice.length), messages: thisSlice } },
        { status: 200 },
      );
    },
  ),
  osano: http.post('https://tattle.api.osano.com/', () => HttpResponse.text('')),
  token: http.post(apiEndpoints.token, () => HttpResponse.json(
    { access_token: getMockedAccessToken(), refresh_token: getMockedAccessToken() },
    { status: 200 },
  )),
};

export const handlersList = Object.values({
  ...handlers,
});
